import {AbstractControl, ValidatorFn} from '@angular/forms';

import {WhitespaceValidatorKey} from './custom-validator-keys';

export function WhitespaceValidator(checkControl = true, value?: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = !checkControl ? value : (control.value && control.value.toString().trim());

        if (!controlValue) {
            return {[WhitespaceValidatorKey]: true};
        }

        return (controlValue.length !== 0) ? null : {[WhitespaceValidatorKey]: true};
    };
}
